import { BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged, finalize, take } from 'rxjs/operators';

export class Loading {
  active$: Observable<boolean>;

  private counter: number = 0;

  private activeSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor() {
    this.active$ = this.activeSubject.pipe(distinctUntilChanged());
  }

  activate<T>(observable$: Observable<T>): Observable<T> {
    this.start();
    return observable$.pipe(
      take(1),
      finalize(() => this.stop()),
    );
  }

  start(): void {
    this.counter++;
    this.activeSubject.next(this.counter > 0);
  }

  stop(): void {
    this.counter--;
    this.activeSubject.next(this.counter > 0);
  }
}

export function activateLoading(loading: Loading): <T>(source: Observable<T>) => Observable<T> {
  return function <T>(source: Observable<T>): Observable<T> {
    if (!loading) {
      return source;
    }

    return loading.activate(source);
  };
}
